/* eslint-disable prefer-template */
/* eslint-disable @typescript-eslint/camelcase */
import { Grid } from '@material-ui/core';
import React from 'react';
import { connect } from 'react-redux';
import ApplicationState from 'store/interfaces';
import Chart from 'chart.js';
import palette from 'theme/palette';
import { SessionsHistoryMonitorGraphFields } from 'modules/monitor/interfaces';

interface Props {
  sessionsHistoryMonitorGraphFields: SessionsHistoryMonitorGraphFields;
}

const InstancesHistoryCardGraphContent = ({
  sessionsHistoryMonitorGraphFields,
}: Props) => {
  const containerRef = React.useRef<HTMLCanvasElement>(null);

  const dateFormat = currentDate => {
    return (
      currentDate.getDate() +
      '/' +
      (currentDate.getMonth() + 1) +
      ' - ' +
      currentDate.toLocaleTimeString('pt-BR', {
        hour12: false,
        hour: 'numeric',
        minute: 'numeric',
      })
    );
  };

  const labels = sessionsHistoryMonitorGraphFields?.metrics.map(item =>
    dateFormat(new Date(item?.timestamp * 1000))
  );

  const data = {
    labels,
    datasets: [
      {
        data: sessionsHistoryMonitorGraphFields.metrics.map(
          item => item.instances.max
        ),
        backgroundColor: palette.yellow,
        borderColor: palette.yellow,
        fill: false,
        tension: 0.4,
      },
    ],
  };

  const config = {
    type: 'line',
    data,
    options: {
      scaleShowLabels: false,
      responsive: true,
      legend: {
        display: false,
      },
      tooltips: {
        callbacks: {
          label(tooltipItem) {
            return tooltipItem.yLabel;
          },
        },
      },
      plugins: {
        legend: {
          display: false,
        },
        filler: {
          propagate: false,
        },
        title: {
          display: false,
        },
      },
      interaction: {
        intersect: true,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: true,
            },
            ticks: {
              display: true,
              fontSize: 10,
            },
          },
        ],
        yAxes: [
          {
            max: 10,
            gridLines: {
              display: true,
            },
            ticks: {
              display: true,
              fontSize: 10,
            },
          },
        ],
      },
    },
  };

  React.useEffect(() => {
    let chart;

    if (containerRef.current) {
      chart = new Chart(containerRef.current, config);
    }
    return () => chart?.destroy();
  }, [containerRef, config]);

  return (
    <Grid container>
      <canvas ref={containerRef} width="auto" height="100"></canvas>
    </Grid>
  );
};

const mapStateToProps = ({
  authenticate: { data, companySelected },
}: ApplicationState) => ({
  companySelected,
  role: data?.role,
});

export default connect(mapStateToProps, {})(InstancesHistoryCardGraphContent);
